import { accountApi } from "infra/axios";

export async function useRecuperarSenha(payload: any, onSuccess?: () => void) {
  const url = `/api/usuario-logado/recuperar-senha`;

  return await accountApi.post(url, payload);
}
